import ImageGroup from './ImageGroup';

const LOW_PRIORITY = 500;

/**
 * Custom properties provider that adds an "Image" group
 * to the properties panel for Task elements.
 */
export default class ImagePropertiesProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
    this._injector = injector;
  }

  getGroups(element) {
    return (groups) => {
      const imageGroup = ImageGroup(element, this._injector);

      if (imageGroup) {
        groups.push(imageGroup);
      }

      return groups;
    };
  }
}

ImagePropertiesProvider.$inject = ['propertiesPanel', 'injector'];
